import { useQuery } from '@tanstack/react-query';
import { toCurrentIdentity } from '../adapters/UsersMe';
import { getMe } from '../clients/GetMe';
import type { ICurrentIdentity } from '../types/UsersMe';

/**
 * No office scope in the key: the person is the token's subject, so switching
 * the selected location must not refetch or fork this cache.
 */
export const currentIdentityKeys = {
  all: ['currentIdentity'] as const,
  me: () => [...currentIdentityKeys.all, 'me'] as const,
};

export const useGetMe = () =>
  useQuery<ICurrentIdentity>({
    queryKey: currentIdentityKeys.me(),
    queryFn: async () => toCurrentIdentity(await getMe()),
  });
